const SuccessSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="160"
    height="160"
    fill="none"
    viewBox="0 0 160 160"
  >
    <path
      fill="url(#paint0_linear_9309_32899)"
      fillOpacity="0.8"
      d="M157.129 74.803c-3.867 11.165-14.149 10.543-28.935 28.79a98 98 0 0 0-2.653 3.426c-6.927 9.364-9.295 16.09-11.707 21.693-.161.376-.326.747-.487 1.113-.747 1.66-1.519 3.225-2.457 4.74-9.008 14.55-28.59 17.194-29.522 17.304q-1.318.164-2.674.231-.414.031-.828.04c-11.375.426-24.215-3.551-31.688-12.484-2.97-3.546-3.918-6.48-5.076-9.134a25 25 0 0 0-.617-1.319c-.958-1.916-2.242-3.711-4.775-5.542-7.489-5.402-11.993-1.033-21.522-6.691-1.66-.983-8.321-5.146-11.491-12.028-.14-.306-.276-.607-.397-.923a18 18 0 0 1-1.203-4.79c-.15-1.434-.241-3.967.727-7.312C5.55 79.07 17.714 79.132 27.274 67.24c11.275-14.03 6.911-29.748 20.062-39.263a33 33 0 0 1 5.236-3.055c4.364-1.99 8.678-2.703 12.43-2.823.345-.016.681-.02 1.017-.02 3.938-.016 7.173.586 9.059.962 16.752 3.3 16.737 13.237 33.911 19.326 13.266 4.7 31.107 5.1 40.832 9.765.221.11.442.216.652.326 1.485.773 2.754 1.656 3.762 2.684.903.923 1.58 1.916 1.58 1.916 1.354 1.98 2.072 4.183 2.398 6.334.055.352.1.703.125 1.044.512 5.176-1.043 9.866-1.219 10.362z"
    ></path>
    <path
      fill="#fff"
      d="M86.162 78.855c-.682.396-1.37.798-2.056 1.189-5.588 3.2-11.516 5.883-17.5 8.26-5.999 2.383-12.108 4.455-18.292 6.295-6.215 1.851-12.49 3.466-18.809 4.926-6.335 1.464-12.71 2.768-19.095 3.987-2.573.487-5.14.968-7.714 1.425-.14-.306-.276-.607-.396-.923 3.426-.642 6.851-1.269 10.272-1.941 6.35-1.249 12.685-2.583 18.99-4.078 6.27-1.485 12.509-3.145 18.673-5.04a228 228 0 0 0 18.137-6.43 189 189 0 0 0 17.54-8.096c.285-.146.526.27.25.426M150.479 52.467c-3.998 2.292-7.649 5.04-10.92 8.296-.11.105-.215.205-.321.316q-.272.27-.536.556c-3.346 3.471-6.28 7.313-8.948 11.316-5.748 8.637-10.187 18.041-15.624 26.859-5.487 8.902-12.243 17.213-21.261 22.731-9.214 5.642-19.908 8.531-30.641 9.128-7.027.391-14.134-.05-21.131-1.143a24 24 0 0 0-.617-1.32c8.587 1.279 17.239 1.957 25.94 1.034 10.74-1.144 21.328-4.444 30.02-11.01 8.451-6.385 14.324-15.413 19.536-24.486 5.091-8.858 9.635-18.057 15.749-26.277 1.816-2.438 3.777-4.835 5.913-7.067.276-.291.562-.577.843-.863 3.35-3.366 7.107-6.31 11.335-8.396.221.11.442.215.652.326z"
    ></path>
    <path
      fill="#fff"
      d="M158.343 64.446c-2.679-.22-5.352-.517-8.01-.863a172 172 0 0 1-11.632-1.95c-.351-.076-.707-.146-1.058-.226A166 166 0 0 1 124.281 58a166.5 166.5 0 0 1-24.812-9.69c-7.88-3.832-15.594-8.261-22.656-13.462-4.53-3.33-9.284-7.534-11.807-12.735.346-.015.682-.02 1.018-.02 3.245 5.938 8.958 10.372 14.475 14.089a161 161 0 0 0 22.852 12.825c8 3.676 16.301 6.69 24.777 9.028q5.14 1.423 10.363 2.508c.356.075.712.145 1.068.22 4.755.959 9.55 1.706 14.37 2.233 1.429.155 2.854.295 4.288.406.056.35.101.702.126 1.043M113.834 128.711c-.161.376-.326.747-.487 1.113-.877.201-1.755.412-2.628.642-3.982 1.029-7.895 2.338-11.636 4.043-3.336 1.52-6.526 3.346-9.465 5.542a43 43 0 0 0-7.624 7.273 37 37 0 0 0-2.984 4.248c-.11.176-.21.346-.316.527q-.414.031-.828.04c.347-.692.733-1.374 1.144-2.041a38 38 0 0 1 3.13-4.294c2.302-2.743 5.02-5.146 7.93-7.232 3.08-2.202 6.415-4.028 9.896-5.517 3.862-1.651 7.874-2.915 11.962-3.903.632-.15 1.269-.301 1.911-.441z"
    ></path>
    <path
      fill="url(#paint1_linear_9309_32899)"
      fillOpacity="0.8"
      d="M104.555 35.167c-1.525-1.937-3.315-5.688-1.931-7.283 3.22-3.712 22.741 5.352 21.994 8.918-.587 2.803-14.415 5.537-20.063-1.636"
    ></path>
    <path
      fill="#fff"
      d="M97.091 53.195h-35.54c-9.134 0-16.537 7.404-16.537 16.537v35.541c0 9.133 7.403 16.537 16.536 16.537h35.541c9.133 0 16.537-7.404 16.537-16.537V69.732c0-9.133-7.404-16.537-16.537-16.537"
    ></path>
    <path
      fill="#fff"
      d="M93.716 56.57H61.55c-9.133 0-16.536 7.404-16.536 16.537v32.166c0 9.132 7.403 16.536 16.536 16.536h32.166c9.133 0 16.537-7.404 16.537-16.536V73.107c0-9.133-7.404-16.537-16.537-16.537"
    ></path>
    <path
      fill="url(#paint2_linear_9309_32899)"
      fillOpacity="0.8"
      d="M79.712 110.676c4.128.832 6.62-.025 8.05-.828 2.648-1.489 3.125-3.616 7.76-11.922 2.12-3.807 3.18-5.708 4.308-7.207 3.4-4.52 7.528-7.158 10.553-8.693.431-.015 1.209.03 1.931.522 1.178.802 1.71 2.453 1.314 4.163v-12.61a96 96 0 0 0-8.411 6.11c-3.862 3.135-6.36 5.16-9.154 8.536-4.55 5.498-7.579 11.782-8.321 14.315-.07.241-.406 1.425-1.114 2.909-.516 1.084-1.003 2.097-1.76 2.879-1.58 1.63-3.917 1.836-5.156 1.831z"
    ></path>
    <path
      fill="url(#paint3_linear_9309_32899)"
      fillOpacity="0.8"
      d="M49.388 69.902c.145-1.32.38-3.496 1.785-5.467 2.157-3.02 5.538-3.411 8.246-3.727 2.944-.341 7.624-.135 8.025 1.615.196.863-.702 1.806-1.113 2.237-2.112 2.212-4.53 1.54-6.802 2.237-5.728 1.76-6.796 11.09-8.807 10.558-1.344-.356-1.63-4.735-1.34-7.453z"
    ></path>
    <path
      fill="url(#paint4_linear_9309_32899)"
      fillOpacity="0.8"
      d="M69.42 63.544c-.356-.838.115-1.951.782-2.548 1.936-1.726 6.571 0 6.686 1.434.08 1.038-2.177 2.242-4.123 2.342-.305.015-2.763.14-3.345-1.223z"
    ></path>
    <path
      fill="url(#paint5_linear_9309_32899)"
      fillOpacity="0.8"
      d="M99.966 99.552c-.04-.627-.01-1.815 1.113-4.012 1.028-2.007 2.438-4.76 3.902-4.57 1.319.17 2.031 2.669 2.227 3.903.462 2.864-.617 6.5-3.12 7.578-.296.126-1.775.722-2.899 0-1.088-.697-1.183-2.202-1.223-2.899"
    ></path>
    <path
      fill="url(#paint6_linear_9309_32899)"
      fillOpacity="0.8"
      d="M96.174 108.574c-.712-1.234.36-3.27 1.56-3.346.777-.045 1.555.733 1.785 1.56.291 1.064-.266 2.418-1.339 2.674-.782.185-1.64-.256-2.006-.893z"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.8"
      d="M93.716 56.57H61.55c-9.133 0-16.536 7.404-16.536 16.537v32.166c0 9.132 7.403 16.536 16.536 16.536h32.166c9.133 0 16.537-7.404 16.537-16.536V73.107c0-9.133-7.404-16.537-16.537-16.537"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.8"
      d="M97.091 53.195h-35.54c-9.134 0-16.537 7.404-16.537 16.537v35.541c0 9.133 7.403 16.537 16.536 16.537h35.541c9.133 0 16.537-7.404 16.537-16.537V69.732c0-9.133-7.404-16.537-16.537-16.537"
    ></path>
    <path
      fill="#000"
      d="M108.918 107.781c-.251.01-.341.286-.441.477-.136.261-.271.516-.422.767a8.4 8.4 0 0 1-1.063 1.425c-.406.436-.843.802-1.304 1.158-.231.181-.491.321-.722.502-.231.18-.562.266-.748.486a.23.23 0 0 0 .161.387c.301.025.637-.201.918-.296.301-.101.612-.316.873-.497a7.3 7.3 0 0 0 1.424-1.299 8 8 0 0 0 1.063-1.6 5.6 5.6 0 0 0 .356-.888c.031-.1.171-.632-.09-.622z"
    ></path>
    <path
      fill="#615FFF"
      d="M74.616 94.798c.592-1.931 8.015-25.64 18.423-36.118 3.24-3.26 7.513-5.994 7.844-6.2 0 0 6.184-3.916 12.91-4.609 1.38-.14 2.313.086 2.955.336a5.8 5.8 0 0 1 1.835 1.164c1.5 1.555 3.531 4.123 4.74 7.754 1.314 3.958.898 6.922.798 7.564-.397 2.543-1.314 3.707-1.635 4.083a6.9 6.9 0 0 1-2.624 1.896 81 81 0 0 0-6.696 3.711c-4.338 2.678-9.454 6.07-14.144 11.06-7.403 7.874-11.034 16.08-12.82 21.176-.155.552-.506 1.469-1.339 2.227a4.6 4.6 0 0 1-1.364.858c-3.712 1.574-8.893 1.148-8.893 1.148-2.272-.185-3.406-.281-4.238-.817-1.55-.999-1.73-2.353-3.23-5.763-.286-.652-1.786-4.023-3.546-6.671-.948-1.43-2.513-3.466-5.036-5.588-.652-.446-1.67-1.309-2.117-2.673-.837-2.553.928-5.01 2.172-6.741 1.139-1.585 2.443-3.396 4.58-3.687 1.037-.14 2.206.086 3.836 1.069 4.74 2.859 7.579 8.607 8.682 11.11"
    ></path>
    <path
      fill="#fff"
      d="M62.242 83.024c.09-.08.693-.607 1.34-.447.787.196 1.048 1.26 1.038 1.856-.01 1.038-.838 2.026-2.082 2.528a5.5 5.5 0 0 0 .221-1.931 5.5 5.5 0 0 0-.522-2.007zM71.828 105.68c.42-1.725 3.907-.772 6.239-3.195.647-.672 1.475-1.881 2.528-3.415.507-.743.928-1.395 1.71-1.56.687-.146 1.575.1 1.856.667.276.547-.125 1.173-.968 2.603-2.197 3.727-1.886 3.526-2.453 4.163-.782.883-1.875 2.117-3.716 2.673-1.625.497-4.188.577-4.98-.742-.066-.11-.367-.612-.222-1.189zM82.972 93.346c-.01-1.284 1.525-2.478 2.603-2.081.883.326 1.415 1.71.893 2.748-.396.788-1.394 1.36-2.302 1.039-.747-.261-1.184-1.029-1.189-1.71z"
    ></path>
    <path
      fill="#000"
      d="M113.959 69.874c.466-.28 3.641-2.172 5.497-1.931.226.03.687.085 1.038.446.582.587.437 1.54.396 1.75a6.3 6.3 0 0 0 1.992-1.905c.546-.833.842-1.746 1.028-3.376.165-1.434.261-3.586-.171-6.264a26 26 0 0 1-.908 2.919c-.511 1.354-.867 2.302-1.6 3.27-.381.507-.887 1.048-2.638 2.267a45 45 0 0 1-4.644 2.824zM68.04 83.358c.517-.025 1.475 0 2.528.482 1.525.697 2.278 1.9 2.528 2.352a4.7 4.7 0 0 0-1.71-1.239 4.7 4.7 0 0 0-2.302-.336l-1.038-1.264z"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.8"
      d="M74.616 94.798c.592-1.931 8.015-25.64 18.423-36.118 3.24-3.26 7.513-5.994 7.844-6.2 0 0 6.184-3.916 12.91-4.609 1.38-.14 2.313.086 2.955.336a5.8 5.8 0 0 1 1.835 1.164c1.5 1.555 3.531 4.123 4.74 7.754 1.314 3.958.898 6.922.798 7.564-.397 2.543-1.314 3.707-1.635 4.083a6.9 6.9 0 0 1-2.624 1.896 81 81 0 0 0-6.696 3.711c-4.338 2.678-9.454 6.07-14.144 11.06-7.403 7.874-11.034 16.08-12.82 21.176-.155.552-.506 1.469-1.339 2.227a4.6 4.6 0 0 1-1.364.858c-3.712 1.574-8.893 1.148-8.893 1.148-2.272-.185-3.406-.281-4.238-.817-1.55-.999-1.73-2.353-3.23-5.763-.286-.652-1.786-4.023-3.546-6.671-.948-1.43-2.513-3.466-5.036-5.588-.652-.446-1.67-1.309-2.117-2.673-.837-2.553.928-5.01 2.172-6.741 1.139-1.585 2.443-3.396 4.58-3.687 1.037-.14 2.206.086 3.836 1.069 4.74 2.859 7.579 8.607 8.682 11.11"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.8"
      d="M60.14 80.664c.638-.311 1.796-.758 3.16-.547.653.1 1.816.421 3.817 2.478a21 21 0 0 1 3.371 4.59 89 89 0 0 1 4.308 9.062M77.635 110.865c.627-.101 2.272-.442 3.707-1.836a6.8 6.8 0 0 0 1.71-2.749 78.7 78.7 0 0 1 7.057-13.672c2.227-3.441 6.445-9.841 13.969-16.126a65.3 65.3 0 0 1 12.559-8.246 12.5 12.5 0 0 0 3.456-2.412c.597-.592 1.906-1.916 2.618-3.847 1.314-3.551-.221-6.932-.637-7.79"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_9309_32899"
        x1="79.722"
        x2="79.722"
        y1="22.078"
        y2="152.171"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6461FF" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#9F47ED" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_9309_32899"
        x1="113.383"
        x2="113.383"
        y1="27.008"
        y2="39.736"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6461FF" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#9F47ED" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_9309_32899"
        x1="96.735"
        x2="96.735"
        y1="74.102"
        y2="111.016"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6461FF" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#9F47ED" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint3_linear_9309_32899"
        x1="58.375"
        x2="58.375"
        y1="60.57"
        y2="77.377"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6461FF" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#9F47ED" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint4_linear_9309_32899"
        x1="73.094"
        x2="73.094"
        y1="60.273"
        y2="64.782"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6461FF" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#9F47ED" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint5_linear_9309_32899"
        x1="103.634"
        x2="103.634"
        y1="90.961"
        y2="102.802"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6461FF" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#9F47ED" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint6_linear_9309_32899"
        x1="97.771"
        x2="97.771"
        y1="105.227"
        y2="109.504"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6461FF" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#9F47ED" stopOpacity="0.4"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default SuccessSvg;
